<template>
  <div>
    <router-link :to="to">
      <q-img
        class="logo"
        :src="src ?? $options.logo"
        contain
      />
    </router-link>
    <ActionsDropdown
      v-if="showSwitcher"
      :menu="actions"
      class="no-hover text-13-400"
      color="primary"
      dropdown-icon="expand_more"
    />
  </div>
</template>

<script>
import logo from 'assets/Logo.svg';
import WebbyfiliateLogo from 'common/assets/webbyfiliate_logo.svg';
import WebbymizeLogo from 'common/assets/webbymize_logo.svg';
import ActionsDropdown from './ActionsDropdown';

export default {
  name: 'WebbymizeLogo',
  components: { ActionsDropdown },
  props: {
    to: {
      type: Object,
      default: () => ({ name: ENUMS.ROUTES.INDEX }),
    },
    showSwitcher: {
      type: Boolean,
      default: false,
    },
    src: {
      type: String,
      default: undefined,
    },
  },
  logo,
  computed: {
    actions() {
      const webbymize = {
        title: 'Webbymize',
        img: WebbymizeLogo,
        handler: this.goToService,
      };
      const webbyfiliate = {
        title: 'Webbyfiliate',
        img: WebbyfiliateLogo,
        handler: this.goToService,
      };

      return [this.$isWebbymize ? webbyfiliate : webbymize];
    },
  },
  methods: {
    goToService() {
      window.location.href = this.$isWebbymize
        ? process.env.AFFILIATE_DOMAIN
        : process.env.WEBBYMIZE_DOMAIN;
    },
  },
};
</script>

<style scoped>
.logo {
  width: 190px;
}
</style>
